import { shipmentPtlAssembleValidate } from "../../application/dtos/shipment_ptl_assemble_validate";

export class shipmentPtlAssembleEntity {
    constructor({id, unique_order_number, shipping_service, shipment_product_detail, client_id}){
        this.id = id;
        this.unique_order_number = unique_order_number;
        this.shipping_service = shipping_service;
        this.shipment_product_detail = shipment_product_detail;
        this.client_id = client_id;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return shipmentPtlAssembleValidate(this);
    }
}